export default __webpack_public_path__ + "static/hfn-logo-black-68e552d82cc939e9553ed3b3f8f4d5f3.svg";